<div *ngIf="data$ | async; else spinner">
    <h2>We have your data ready!</h2>
</div>
<ng-template #spinner>
    <mat-spinner></mat-spinner>
</ng-template>
